import { useMemo } from "react";
import FormItemsContainer from "../../../containers/FormItemsContainer";

// NOTE: ポータルの検索UIで使う searchItems の引き当てを安定キー(name)ベースで一元化する
function usePortalSearchItems() {
  const { searchItems } = FormItemsContainer.useContainer();

  return useMemo(() => {
    // NOTE: backendがitemsを絞るページ(トピック等)では選択肢の無い項目をundefinedにしてセクションごと非表示にする
    const byName = (name: string) => {
      const found = searchItems.find(
        (s: { name?: string; items?: unknown[] }) => s.name === name
      );
      return found?.items ? found : undefined;
    };

    return {
      kindItem: byName("kind"),
      genreItem: byName("genre"),
      positionItem: byName("position"),
      characteristicItem: byName("characteristic"),
      atmosphereItem: byName("atmosphere"),
      skillItem: byName("skill"),
      termItem: byName("activity_term"),
      priceItem: byName("price_category"),
      // NOTE: dateはitemsを持たない項目
      dateItem: searchItems.find((s: { name?: string }) => s.name === "date"),
    };
  }, [searchItems]);
}

export default usePortalSearchItems;
